import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AppInformationService, GenesisUnitOfWork, EntitiesService, AuthService, UtilityService } from 'app/core/core.module';
import moment from 'moment';
import _ from 'lodash';
import { DxDataGridComponent } from 'devextreme-angular';
import { confirm, alert } from 'devextreme/ui/dialog';

@Component({
    selector: 'app-quickbooks-export-dialog',
    templateUrl: './quickbooks-export-dialog.component.html',
    styleUrls: ['./quickbooks-export-dialog.component.scss'],
    standalone: false
})
export class QuickbooksExportDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    items: any[];
    mode: any;
    showingResults = false;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(
        public modalRef: BsModalRef,
        private uow: GenesisUnitOfWork,
        private appInfo: AppInformationService,
        private modalService: BsModalService,
        private entitiesService: EntitiesService,
        private auth: AuthService,
        private utility: UtilityService
    ) {}

    async ngOnInit() {
        this.getData();
    }

    getData() {
        if (this.mode === 'Invoice') {
            this.items.forEach(x => {
                x.markedBy = (_.find(this.uow.lookups.users, { 'id': x.markedReadyById}) as any).userName;
            });
        }
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons',
        },
        {
            template: 'toolbarText',
            location: 'after',
        },

        );
    }

    async save() {
        this.result.next({ success: true });
        this.modalRef.hide();
    }

    cancel() {
        // this.uow.rollback();
        this.modalRef.hide();
    }
}
